/*
*/

export const ArticleTile = {
  articleMargin: 40,
  articleInfoOverlap: 54,
};

export const BreakPoints = {
  mobile: {
    size: 320,
    key: '-mobile-',
  },
  tablet: {
    size: 600,
    key: '-tablet-',
  },
  desktop: {
    size: 1024,
    key: '-desktop-',
  },
};

export const MaxBrowserWidth = 1280;

export const ResponsiveSizes = [
  400, 600, 800, 1200,
];

export const ResponsiveMax = 1200;

export const Events = {
  TappedArticle: '--tapped-article--',
};

// location of responsive images, generated by 'get-responsive-images'
export const ResponsivePathName = 'responsive';

/*
  definitions for work tile offsets
  in CMS - 'large', 'medium', 'small'
*/
export const WorkImageOffsets = {
  large: 100,
  medium: 50,
  small: 20,
};

export const DefaultAspectRatio = 'square';

export const CategoryTileDims = {
  desktop: {
    w: 703,
    h: 205,
    gridGap: 32,
  },
};

const catW = CategoryTileDims.desktop.w;
const catH = CategoryTileDims.desktop.h;

export const AspectRatios = {
  // category tile ar
  '7:2': (catW / catH),
  '2:7': (catH / catW),

  '25:9': (25 / 9),
  '21:9': (21 / 9),
  '16:9': (16 / 9),
  '4:3': (4 / 3),
  '1:1': (1 / 1),
  '3:4': (3 / 4),
  '9:16': (9 / 16),
  '9:21': (9 / 21),
  '9:25': (9 / 25),
};



// WEBPACK FOOTER //
// ./src/app-constants.js